// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"490":"63dc814bb551b076","8537":"8a1d752fa81c1522"}[chunkId] + ".js";
};